"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScientificCommunityRebalanced = void 0;
var GlobalEventName_1 = require("./GlobalEventName");
var PartyName_1 = require("../parties/PartyName");
var Resources_1 = require("../../Resources");
var ScientificCommunityRebalanced = (function () {
    function ScientificCommunityRebalanced() {
        this.name = GlobalEventName_1.GlobalEventName.SCIENTIFIC_COMMUNITY_REBALANCED;
        this.description = 'Gain 1 M€ for each card in hand (max 15) and influence.';
        this.revealedDelegate = PartyName_1.PartyName.REDS;
        this.currentDelegate = PartyName_1.PartyName.SCIENTISTS;
    }
    ScientificCommunityRebalanced.prototype.resolve = function (game, turmoil) {
        var _this = this;
        game.getPlayers().forEach(function (player) {
            var amount = Math.min(player.cardsInHand.length, 15) + turmoil.getPlayerInfluence(player);
            player.addResource(Resources_1.Resources.MEGACREDITS, amount, { log: true, from: _this.name });
        });
    };
    return ScientificCommunityRebalanced;
}());
exports.ScientificCommunityRebalanced = ScientificCommunityRebalanced;
//# sourceMappingURL=ScientificCommunityRebalanced.js.map